import { render, staticRenderFns } from "./YDY.vue?vue&type=template&id=3eab3449&scoped=true&"
import script from "./YDY.vue?vue&type=script&lang=js&"
export * from "./YDY.vue?vue&type=script&lang=js&"
import style0 from "./YDY.vue?vue&type=style&index=0&id=3eab3449&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eab3449",
  null
  
)

export default component.exports